import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

interface BarcodeDetectorCtor {
  new (options?: { formats?: string[] }): {
    detect(source: ImageBitmapSource): Promise<Array<{ rawValue: string }>>;
  };
  getSupportedFormats?(): Promise<string[]>;
}

function getDetectorCtor(): BarcodeDetectorCtor | null {
  const w = globalThis as unknown as { BarcodeDetector?: BarcodeDetectorCtor };
  return w.BarcodeDetector ?? null;
}

export function isBarcodeScanSupported(): boolean {
  return getDetectorCtor() !== null;
}

export async function scanBarcode(): Promise<string> {
  const Detector = getDetectorCtor();
  if (!Detector) throw new Error('Scansione non supportata su questo dispositivo');

  const photo = await Camera.getPhoto({
    quality: 80,
    allowEditing: false,
    resultType: CameraResultType.Base64,
    source: CameraSource.Camera,
    correctOrientation: true,
  });
  if (!photo.base64String) throw new Error('Nessuna foto acquisita');

  const bytes = Uint8Array.from(atob(photo.base64String), (c) => c.charCodeAt(0));
  const blob = new Blob([bytes], { type: 'image/jpeg' });
  const bitmap = await createImageBitmap(blob);
  const detector = new Detector({
    formats: ['code_128', 'code_39', 'ean_13', 'ean_8', 'qr_code', 'upc_a', 'upc_e'],
  });
  const results = await detector.detect(bitmap);
  if (results.length === 0) throw new Error('Nessun codice riconosciuto');
  return results[0].rawValue;
}
